module.exports = __webpack_public_path__ + "static/media/circle-check-big.1ee4a930.svg";